import { createReducer, on } from '@ngrx/store';
import { addCustomLoader, changeLanguage, removeCustomLoader, setHttpLoadingStatus } from './app.actions';
import { environment } from '../../environments/environment.development';

export interface AppState {
  isHttpLoading: boolean;
  customLoaders: string[];
  availableLanguages: string[];
  language: string;
}

export const initialAppState: AppState = {
  isHttpLoading: true,
  customLoaders: [],
  availableLanguages: environment.languages,
  language: environment.defaultLanguage,
};

export const appReducer = createReducer<AppState>(
  initialAppState,
  on(setHttpLoadingStatus, (state, { isLoading }) => {
    return {
      ...state,
      isHttpLoading: isLoading,
    };
  }),
  on(addCustomLoader, (state, { loaderName }) => {
    return {
      ...state,
      customLoaders: [...state.customLoaders, loaderName],
    };
  }),
  on(removeCustomLoader, (state, { loaderName }) => {
    return {
      ...state,
      customLoaders: state.customLoaders.filter((name) => name !== loaderName),
    };
  }),
  on(changeLanguage, (state, { language }) => {
    return {
      ...state,
      language,
    };
  }),
);
